import axios from "axios";
import { verificationSlice, callTypes } from "./verificationSlice";
const API_URL = process.env.REACT_APP_API_URL;

const { actions } = verificationSlice;

export const fetchVerifications = () => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));

  return axios
    .get(API_URL + "verifications/?status=PENDING")
    .then((response) => {
      dispatch(
        actions.verificationsFetched({ verificationList: response.data })
      );
    })
    .catch((err) => {
      dispatch(
        actions.catchError({
          error: err,
          callType: callTypes.action,
        })
      );
    });
};

export const actionIdentityVerification = (id, body) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  return axios
    .put(API_URL + `verifications/verify/${id}`, body)
    .then((response) => {
      dispatch(
        actions.verificationSolved({ verificationStatus: response.data })
      );
    })
    .catch((err) => {
      dispatch(actions.catchError({ error: err, callType: callTypes.action }));
    });
};
